import {GenericDgSearchResults} from "./generic.dg-search-results.model";
import {UserCarePlan} from "../user-care-plan.model";

export class UserCarePlanDgSearchResults extends GenericDgSearchResults {
  public results: UserCarePlan[];

  constructor(total: number, results: UserCarePlan[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}

